import Tab from '@material-ui/core/Tab';
import TabPanel from 'components/TabPanel/TabPanel';
import React, { useState } from 'react';
import * as Styles from './InspectionFiles.styles';
import { ACTIVE_TAB_ENUM, IInspectionFilesProps } from './InspectionFiles.types';
import DocumentActions from './components/DocumentActions/DocumentActions';
import PhotoActions from './components/PhotoActions/PhotoActions';
import RegulationActions from './components/RegulationActions/RegulationActions';
import TabDocuments from './components/TabDocuments/TabDocuments';
import TabPhotos from './components/TabPhotos/TabPhotos';
import TabRegulation from './components/TabRegulation/TabRegulation';
import TabHistory from './components/TabHistory/TabHistory';

const InspectionFiles = ({ inspection, actionsVisible = true }: IInspectionFilesProps) => {
  const [activeTab, setActiveTab] = useState<ACTIVE_TAB_ENUM>(ACTIVE_TAB_ENUM.TAB_PHOTO);
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(true);

  const toggleAccordionExpanded = () => setIsAccordionExpanded((previous) => !previous);

  const handleTabsChange = (_: React.SyntheticEvent<Element, Event>, newValue: ACTIVE_TAB_ENUM) => {
    setActiveTab(newValue);
  };

  const getPhotosCount = () => {
    return inspection.photos?.filter((photo) => photo.origin !== 'UPLOAD_KITE_REGULATION').length || 0;
  };

  const getDocumentsCount = () => {
    return inspection.files?.filter((file) => file.origin !== 'UPLOAD_KITE_REGULATION').length || 0;
  };

  const getRegulationFilesCount = () => {
    const regulationPhotos =
      inspection.photos?.filter((photo) => photo.origin === 'UPLOAD_KITE_REGULATION').length || 0;
    const regulationDocuments =
      inspection.files?.filter((file) => file.origin === 'UPLOAD_KITE_REGULATION').length || 0;
    return regulationPhotos + regulationDocuments;
  };

  const getHistoryCommentsCount = () => {
    return inspection.comments?.length || 0;
  };

  const renderActionsMenu = () => {
    const actionsMenu = {
      [ACTIVE_TAB_ENUM.TAB_PHOTO]: <PhotoActions inspection={inspection} />,
      [ACTIVE_TAB_ENUM.TAB_DOCS]: <DocumentActions inspection={inspection} />,
      [ACTIVE_TAB_ENUM.TAB_REGULATION]: <RegulationActions inspection={inspection} />,
      [ACTIVE_TAB_ENUM.TAB_HISTORY]: null,
    };

    return actionsMenu[activeTab];
  };

  return (
    <>
      <Styles.Accordion data-testid="inspection-files-accordion" expanded={isAccordionExpanded}>
        <Styles.Summary
          data-testid="inspection-files-accordion-summary"
          expandIcon={<Styles.ExpandIcon />}
          IconButtonProps={{ onClick: toggleAccordionExpanded, id: 'expand-button' }}
        >
          <Styles.TabsBase value={activeTab} onChange={handleTabsChange}>
            <Tab disableRipple label={`Fotos (${getPhotosCount()})`} value={ACTIVE_TAB_ENUM.TAB_PHOTO} />
            <Tab disableRipple label={`Documentos (${getDocumentsCount()})`} value={ACTIVE_TAB_ENUM.TAB_DOCS} />
            <Tab
              disableRipple
              label={`Regulação (${getRegulationFilesCount()})`}
              value={ACTIVE_TAB_ENUM.TAB_REGULATION}
            />
            <Tab
              disableRipple
              label={`Histórico e comentários (${getHistoryCommentsCount()})`}
              value={ACTIVE_TAB_ENUM.TAB_HISTORY}
            />
          </Styles.TabsBase>
          {actionsVisible && renderActionsMenu()}
        </Styles.Summary>
        <Styles.Details>
          <TabPanel value={activeTab} tabName={ACTIVE_TAB_ENUM.TAB_PHOTO}>
            <TabPhotos inspection={inspection} />
          </TabPanel>
          <TabPanel value={activeTab} tabName={ACTIVE_TAB_ENUM.TAB_DOCS}>
            <TabDocuments inspection={inspection} />
          </TabPanel>
          <TabPanel value={activeTab} tabName={ACTIVE_TAB_ENUM.TAB_REGULATION}>
            <TabRegulation inspection={inspection} />
          </TabPanel>
          <TabPanel value={activeTab} tabName={ACTIVE_TAB_ENUM.TAB_HISTORY}>
            <TabHistory inspection={inspection} />
          </TabPanel>
        </Styles.Details>
      </Styles.Accordion>
    </>
  );
};

export default InspectionFiles;
